import CommonUtil from "utils/CommonUtil";

/**
 * 환경설정 RestRepository
 */

class ConfigRestRepository {
    /**
     * 환경설정 조회
     */
    public async readConfig(): Promise<any> {
        return await CommonUtil.execute({
            url: "com_config"
        })
            .then((response: any) => {
                return {
                    locale: response.LOCALE,
                    systemMode: response.SYSTEM_MODE
                }
            })
            .catch((error) => CommonUtil.showAxiosError(error))

    };
}
const configRestRepository = new ConfigRestRepository();

export default configRestRepository;
